import { queryKeys } from './queryKeys'

/** Prefix for all content-review notification queries (dashboard + campaign detail). */
export const CONTENT_REVIEW_NOTIFICATIONS_KEY = ['content-review-notifications']

/**
 * Invalidate caches after content upload, submit, approve, or review-thread activity.
 */
export function invalidateAfterContentChange(queryClient, { campaignId } = {}) {
  queryClient.invalidateQueries({ queryKey: queryKeys.content.all })
  queryClient.invalidateQueries({ queryKey: CONTENT_REVIEW_NOTIFICATIONS_KEY })
  if (campaignId) {
    queryClient.invalidateQueries({ queryKey: queryKeys.campaigns.detail(campaignId) })
  }
}

export function invalidateAfterRosterChange(queryClient, campaignId) {
  if (campaignId) {
    queryClient.invalidateQueries({ queryKey: queryKeys.proposedInfluencers.list(campaignId) })
    queryClient.invalidateQueries({ queryKey: queryKeys.campaigns.detail(campaignId) })
  }
  queryClient.invalidateQueries({ queryKey: queryKeys.campaigns.all })
  queryClient.invalidateQueries({ queryKey: queryKeys.stats.all })
}

export function invalidateAfterInfluencerRosterChange(queryClient, { campaignId } = {}) {
  queryClient.invalidateQueries({ queryKey: queryKeys.influencers.all })
  if (campaignId) {
    queryClient.invalidateQueries({ queryKey: queryKeys.campaigns.detail(campaignId) })
  }
}

/** After a creator accepts (or declines) a campaign invitation — refresh dashboard + tasks. */
export function invalidateAfterInfluencerInvitationChange(queryClient) {
  queryClient.invalidateQueries({ queryKey: queryKeys.influencers.all })
  queryClient.invalidateQueries({ queryKey: queryKeys.campaigns.all })
  queryClient.invalidateQueries({ queryKey: queryKeys.content.all })
  queryClient.invalidateQueries({ queryKey: queryKeys.stats.all })
}
